import { Component } from "react"

/* REST API */
import { saveGame } from "../api/Game"

/* Styles (анимация звезды) */
import "./SaveStar.css"


/* Общая «звезда» сохранения игры.
   props: gameID, postfix, saved (нач. состояние из списка), onToggle(saved) */
class SaveStar extends Component {

    constructor(props) {
        super(props)

        this.state = {
            saved: this._toBool(props.saved),
            loading: false,
            animate: false,
        }

        this._animTimer = null
    }

    _toBool = (value) => !!(value && parseInt(value) > 0)

    componentDidUpdate = (prevProps) => {
        /* Синхронизируем при перезагрузке списка */
        if (prevProps.saved !== this.props.saved) {
            this.setState({ saved: this._toBool(this.props.saved) })
        }
    }

    componentWillUnmount = () => {
        if (this._animTimer) {
            clearTimeout(this._animTimer)
        }
    }

    toggle = (event) => {

        /* Не открывать игру по клику на звезду */
        if (event) {
            event.stopPropagation()
        }

        if (this.state.loading) {
            return
        }

        /* Анимация «pop» при нажатии */
        this.setState({ animate: true })
        if (this._animTimer) {
            clearTimeout(this._animTimer)
        }
        this._animTimer = setTimeout(() => this.setState({ animate: false }), 420)

        const { gameID, postfix, onToggle } = this.props

        this.setState({ loading: true })

        saveGame({ gameID, postfix: postfix !== undefined && postfix !== null ? postfix : "" }).then((response) => {
            if (response && response.status === 200 && response.data) {
                const saved = !!response.data.saved
                this.setState({ saved, loading: false })
                if (onToggle) {
                    onToggle(saved)
                }
            }
            else {
                this.setState({ loading: false })
            }
        }).catch(() => this.setState({ loading: false }))
    }

    render = () => {

        const { saved, loading, animate } = this.state

        const color = saved ? "#f5b301" : "#c2c7cf"

        return (
            <div
                onClick={this.toggle}
                title={saved ? "Убрать из сохранённых" : "Сохранить"}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: loading ? "default" : "pointer",
                    opacity: loading ? 0.5 : 1,
                    padding: "0 6px",
                    marginRight: 15,
                }}
            >
                <svg viewBox="0 0 24 24" width="24" height="24" className={`save-star-svg ${animate ? "pop" : ""}`}>
                    <path
                        d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77 5.82 21l1.18-6.88-5-4.87 7.1-1.01L12 2z"
                        fill={saved ? color : "none"}
                        stroke={color}
                        strokeWidth="1.6"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        )
    }

}

export default SaveStar
